<template>
  <div class="ql-snow">
    <div
      :class="adjunctiveClass"
      class="ql-editor"
      v-html="richText"
      @click="addComment($event)"
    ></div>
    <van-image-preview v-model="show" :images="images"></van-image-preview>
  </div>
</template>
<script>
export default {
  props: {
    richText: {
      type: String
    }
  },
  components: {},
  mixins: [],
  data() {
    return {
      show: false,
      images: []
    }
  },
  watch: {},
  computed: {
    adjunctiveClass() {
      let reg = /font-size:[0-9.]+rem/i
      if (reg.test(this.richText)) {
        return 'richText'
      } else {
        return ''
      }
    }
  },
  mounted() {},
  created() {},
  filters: {},
  methods: {
    addComment: function(event) {
      switch (event.target.nodeName) {
        case 'A': {
          event.preventDefault()
          const url = event.target.href
          const fileType = url.substring(url.lastIndexOf('.') + 1)
          try {
            let options = {
              source: '活动资讯',
              fileType,
              url
            }
            window.bridge.onFileDownload(JSON.stringify(options))
          } catch (error) {
            console.log('调用APP下载方法失败')
            window.open(event.target.href)
          }
          break
        }
        case 'IMG': {
          if (event.target.parentNode.tagName !== 'A') {
            event.preventDefault()
            this.images = [event.target.currentSrc]
            this.show = true
          }
          break
        }
      }
    }
  }
}
</script>
<style lang="css" scoped></style>
